/* @flow */

import { rem } from 'polished';

import { baseFontSize } from '@e180/ui/lib/token/typography';
import { listReset } from 'src/shared/app/base/style/token/helper';
import { topBarHeight } from 'src/shared/app/nav/style/nav.style';

export default {
  section: {
    padding: [
      `calc(${topBarHeight}px + ${rem(0, baseFontSize)})`,
      rem(16, baseFontSize),
    ],
  },
  instruction: {
    margin: [rem(16, baseFontSize), 0],
  },
  list: {
    extend: listReset,
  },
};
